import FirestoreService from "../firestore";
import { Pollutant } from "@/types/pollutant/pollutant.types";

interface FirestoreResponse {
    entity?: string;
    [key: string]: any;
}

export const pollutantService = {
    create: async (body: Omit<Pollutant, "id" | "createdAt" | "updatedAt">, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "create-pollutant",
            body,
            "setup_pollutants",
            issuedBy
        )) as FirestoreResponse;

        const documentId = result?.entity;
        if (!documentId) {
            throw new Error("Failed to create pollutant: No ID returned");
        }
        return documentId;
    },

    edit: async (id: string, body: Partial<Pollutant>, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "edit-pollutant",
            { id, ...body },
            "setup_pollutants",
            issuedBy
        )) as FirestoreResponse;
        return result;
    },

    delete: async (id: string, issuedBy?: string) => {
        return FirestoreService.request(
            "delete-pollutant",
            { id },
            "setup_pollutants",
            issuedBy
        ) as Promise<FirestoreResponse>;
    }
}; 